import { Application } from "@hotwired/stimulus";
import CheckboxSelectAll from "stimulus-checkbox-select-all/dist/stimulus-checkbox-select-all.umd";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

const application = Application.start();
application.register("checkbox-select-all", CheckboxSelectAll);
const context = require.context(".", true, /\.js$/);
application.load(definitionsFromContext(context));
